module.exports = __webpack_public_path__ + "static/media/COTK2_2.2a1075ee.png";